import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next"; 
import { Container, Navbar} from "reactstrap";
import "./BottomBar.css"; 

class BottomBar extends Component {

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        
        this.state = {
            collapsed: true,
            userIsAuthenticated: false
        };
    }

    async componentDidMount() {
        try {
            // Call server to see if user is authenticated
            const res = await fetch("/Account/whoami", { credentials: "include" });
            if (res.ok) {
                const data = await res.json();
                this.setState({ userIsAuthenticated: data.isAuthenticated });
            } else {
                this.setState({ userIsAuthenticated: false });
            }
        } catch (err) {
            console.error("Error checking user authentication:", err);
            this.setState({ userIsAuthenticated: false });
        }
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    doLogin() {
        // Redirect to MVC login page
        window.location.href = "/Account/Login";
    }

    doLogout() {
        // Call logout endpoint on server
        fetch("/Account/Logout", { method: "POST", credentials: "include" })
            .then(() => window.location.href = "/") // redirect after logout
            .catch(err => console.error("Logout failed:", err));
    }

    render() {
        const t = this.props.t;

        return (
            <footer className="ShipsRadioFooter">    
                <Navbar className="navbar-expand-md border-bottom box-shadow mb-3" dark style={{ backgroundColor: "#004D44" }}>
                    <Container>
                        <div className="row">
                            <div className="col-md-1">
                                <div className="HarpImage mx-1" ></div>
                            </div>
                        </div>
                            <div className="col-md-11">
                            <div className="footer-main-text-div"> {t("Common.FooterInfo")}</div>
                            <div className="footer-main-text-div">
                                <label className="footer-label">Email:&nbsp;</label>
                                <a href="mailto:IMRAD@transport.gov.ie">IMRAD@transport.gov.ie</a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                <label className="footer-label">Telephone: </label>
                                    {t("Common.FooterPhone")}
                                </div>
                            </div>

                    </Container>
                </Navbar>
           
            </footer >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userRole: state.currentUserInfo.role || ""
    };
};

const languageAwareComponent = withTranslation()(BottomBar);
export default connect(mapStateToProps, null)(languageAwareComponent);